import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatPaginatorModule, MatSortModule, MatTableModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '@tc/pipes';
import { RoomCostSetupDataCardComponent } from './room-cost-setup-data-card.component';

@NgModule({
    declarations: [RoomCostSetupDataCardComponent],
    imports: [
        TranslateModule.forChild(),
        CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        PipesModule
    ],
    exports: [
        RoomCostSetupDataCardComponent
    ]
})
export class RoomCostSetupDataCardModule {}
